import useStepperPage from "@/shared/hooks/useStepperPage";
import { createPageTitle } from "@/shared/routing/TitleGuard";
import { RacwaStepperTemplate } from "@racwa/react-components";
import { RouteObject } from "react-router-dom";
import Form from "./Form";
import { useYourFence } from "./hooks/useYourDamagedFence";

export const pageName = "Your damaged fence";

export const YourFence = () => {
  const props = useYourFence();
  const stepperProps = useStepperPage();

  return (
    <RacwaStepperTemplate {...stepperProps}>
      <Form {...props} />
    </RacwaStepperTemplate>
  );
};

export const YourDamagedFenceRoute = {
  path: "your-damaged-fence",
  element: <YourFence />,
  loader: () => (document.title = createPageTitle(pageName)),
} as const satisfies RouteObject;

export default YourFence;
